import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Mail, Phone } from "lucide-react";

const STATUSES = ["new", "contacted", "closed"];

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/inquiries").then((r) => setItems(r.data || [])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/admin/inquiries/${id}`, { status });
      setItems((arr) => arr.map((x) => (x.id === id ? { ...x, status } : x)));
    } catch {
      toast.error("Failed to update");
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm("Delete this inquiry?")) return;
    try {
      await api.delete(`/admin/inquiries/${id}`);
      toast.success("Deleted");
      load();
    } catch {
      toast.error("Failed to delete");
    }
  };

  return (
    <div data-testid="admin-inquiries">
      <div className="section-label mb-3">Clients</div>
      <h1 className="font-display text-3xl md:text-4xl font-light">Inquiries</h1>

      <div className="mt-8 space-y-3">
        {loading && <div className="text-zinc-500 text-sm">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="border border-white/5 bg-[#0F0F0F] p-10 text-center text-zinc-500">
            No inquiries yet.
          </div>
        )}
        {!loading && items.map((it) => (
          <div key={it.id} className="border border-white/5 bg-[#0F0F0F] p-5" data-testid={`inquiry-${it.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <div className="font-display text-lg text-white">{it.name}</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-1">
                  {new Date(it.created_at).toLocaleString()}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <select
                  value={it.status}
                  onChange={(e) => updateStatus(it.id, e.target.value)}
                  className="ec-input !py-2 !px-3 !text-xs tracking-widest uppercase"
                  data-testid={`inquiry-status-${it.id}`}
                >
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button
                  onClick={() => onDelete(it.id)}
                  className="w-9 h-9 border border-white/10 text-zinc-300 hover:border-red-500 hover:text-red-500 flex items-center justify-center"
                  data-testid={`delete-inquiry-${it.id}`}
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <a href={`mailto:${it.email}`} className="flex items-center gap-2 text-zinc-300 hover:text-[#C6A15B]">
                <Mail size={13} className="text-[#C6A15B]" /> {it.email}
              </a>
              <a href={`tel:${it.phone}`} className="flex items-center gap-2 text-zinc-300 hover:text-[#C6A15B]">
                <Phone size={13} className="text-[#C6A15B]" /> {it.phone}
              </a>
              <div className="text-zinc-300">
                <span className="text-zinc-500 text-xs uppercase tracking-widest mr-2">Budget:</span>
                {it.budget || "—"}
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-white/5">
              <div className="text-xs uppercase tracking-widest text-zinc-500 mb-1">Preference</div>
              <div className="text-white text-sm">{it.car_preference}</div>
              {it.message && (
                <>
                  <div className="text-xs uppercase tracking-widest text-zinc-500 mt-3 mb-1">Message</div>
                  <div className="text-zinc-300 text-sm whitespace-pre-wrap">{it.message}</div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
